import agriculture2 from "../../assets/images/indicators/agriculture2.jpg";
import agriculture3 from "../../assets/images/indicators/agriculture3.jpg";
import water2 from "../../assets/images/indicators/water2.jpg";
import water3 from "../../assets/images/indicators/water3.jpg";
import eco2 from "../../assets/images/indicators/eco2.jpg";
import eco3 from "../../assets/images/indicators/eco3.jpg";

const ElementsData = [
  {
    category: "Agriculture",
    items: [
      {
        image: agriculture2,
        cardTitle: "Grain output per unit labor force",
        itemDescription:
          "This refers to the amount of grain produced per unit of labor input. It is a measure of agricultural productivity that indicates how efficiently labor is used to produce a given amount of grain.",
        route: "/pages/blogs/author",
      },
      {
        image: agriculture3,
        cardTitle: "Land intensity per unit of output",
        itemDescription:
          "This is a measure of land use efficiency in agriculture. It refers to the amount of land required to produce a unit of output, such as a ton of grain. A lower land intensity per unit of output indicates higher efficiency in land use.",
        route: "/pages/blogs/author",
      },
    ],
  },
  {
    category: "Water",
    items: [
      {
        image: water2,
        cardTitle: "Water body distribution data",
        itemDescription:
          "Water body distribution data is to describe the spatial distribution of inra-year stable inland water bodies,  including both lakes and rivers in the Hindu Kush Himalaya. Most of the surface water bodies in the region are concentrated in the endorheic basin of Tibetan Plateau. A pixel with a pixel value of 1 is a water pixel, and a pixel value of 0 is a non-water pixel.",
        route: "/data-map/aircas_water_distribution_yearly",
      },
      {
        image: water3,
        cardTitle: "Water clarity data",
        itemDescription:
          "Water clarity is a descriptive term for how deeply visible light penetrates through water. It is one of the most important water quality parameters, and is directly related to the the suspended matter, planktonic algae, and colored dissolved organic matter in the water column. This water clarity data can reflect the comprehensively quality of surface water in the Hindu Kush Himalaya. The higher the pixel value, the higher the water body clarity and the better the water quality.",
        route: "/data-map/aircas_water_clarity_yearly",
      },
    ],
  },
  {
    category: "Ecology",
    items: [
      {
        image: eco2,
        cardTitle: "Forest and grassland cover",
        itemDescription:
          "This dataset utilizes Landsat data and is subjected to terrain correction and BRDF correction processes. Forest and grass are extracted using the random forest method, with a sample dataset established for HKH.",
        route: "/data-map/aircas_forest_and_grass_distribution_yearly",
      },
      {
        image: eco3,
        cardTitle: "Fractional vegetation cover",
        itemDescription:
          "This dataset utilizes Landsat images and is subjected to terrain correction and BRDF correction processes. A standard sample library, which considered both land cover types and terrain characteristics, is established. A transfer learning method is adopted to calculate the vegetation coverage.",
        route: "/data-map/aircas_FVC_yearly",
      },
    ],
  },
];

export default ElementsData;
